export const state = {
  modalViewDiscountCoupon: false,
  discountCoupons: [],
  discountCoupon: {}
};

export default {};
